import clsx from 'clsx';

import { IProfileContainerBodyProps } from '../types';

const ProfileContainerBody = ({ className, children }: IProfileContainerBodyProps) => {
  return <div className={clsx(className, 'p-16')}>{children}</div>;
};

export default ProfileContainerBody;
